import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FiShoppingCart } from "react-icons/fi";
import { LuUtensils } from "react-icons/lu";

import {
  increaseCount,
  decreaseCount,
  removeFromCart,
  setNote,
} from "../store/features/cartSlice";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";

const CartMenu = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.cart);
  const note = useSelector((state) => state.cart.note);

  console.log({ cart });

  const navigate = useNavigate();

  const cartTotal = cart.reduce(
    (acc, item) => acc + item.price * item.count,
    0,
  );

  /* ================= EMPTY CART ================= */

  if (!cart || cart.length === 0) {
    return (
      <div className="min-h-[75vh] flex flex-col items-center justify-center text-center px-6 text-dry">
        <h1 className="text-3xl font-serif mb-10">Your Order</h1>

        <div className="border-t border-b py-16 w-full max-w-xl flex flex-col items-center">
          <FiShoppingCart className="text-6xl mb-6 text-gray-400" />

          <p className="text-xl font-serif">Your cart is currently empty</p>

          <p className="text-gray-500 mt-3 text-sm">
            Start adding delicious dishes to your order.
          </p>

          <button
            onClick={() => navigate("/menu")}
            className="mt-10 bg-black text-white px-8 py-3 uppercase tracking-widest hover:opacity-90 transition"
          >
            Continue Order
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-6 py-20 text-dry">
      {/* Title */}
      <h1 className="text-3xl font-serif text-center mb-14 mt-10 uppercase tracking-wide">
        Your Cart
      </h1>

      {/* Header */}
      <div className="hidden md:grid grid-cols-12 text-sm uppercase tracking-widest border-b pb-4 mb-8">
        <div className="col-span-6"></div>
        <div className="col-span-2 text-right">Price</div>
        <div className="col-span-2 text-right">Quantity</div>
        <div className="col-span-2 text-right">Total</div>
      </div>

      {/* Cart Items */}
      <div className="space-y-3">
        {cart.map((item) => (
          <div
            key={item._id}
            className="grid grid-cols-1 md:grid-cols-12 gap-3 items-center border-b pb-10"
          >
            {/* LEFT SIDE */}
            <div className="md:col-span-6 flex gap-3 items-start ">
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-20 h-20 object-cover rounded "
                />
              ) : (
                <div className="w-20 h-20 flex items-center justify-center  rounded ">
                  <LuUtensils className="w-10 h-10 text-gray-400" />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <h3 className="text-lg font-serif font-semibold uppercase">
                  {item.title}
                </h3>
                {/* <p className="text-sm text-gray-500 mt-1">{item.desc}</p> */}
                {item.selectedOption && (
                  <p className="text-sm text-neonYellow mt-1">
                    {item.selectedOption}
                  </p>
                )}
              </div>
            </div>

            {/* PRICE */}
            <div className="md:col-span-2 text-right justify-end hidden lg:flex">
              ${item.price.toFixed(2)}
            </div>

            {/* QUANTITY */}
            <div className="md:col-span-2 flex justify-end">
              <div className="flex border rounded">
                <button
                  onClick={() => dispatch(decreaseCount(item))}
                  className="px-3 py-1 hover:bg-gray-100"
                >
                  −
                </button>

                <span className="px-4 py-1 border-x">{item.count}</span>

                <button
                  onClick={() => dispatch(increaseCount(item))}
                  className="px-3 py-1 hover:bg-gray-100"
                >
                  +
                </button>
              </div>
            </div>

            {/* TOTAL + REMOVE */}
            <div className="col-span-1 md:col-span-2 flex items-center justify-end gap-4">
              <div className="font-medium">
                ${(item.price * item.count).toFixed(2)}
              </div>

              <button
                onClick={() => dispatch(removeFromCart(item))}
                className="p-2 rounded-full text-gray-500 hover:bg-red-100 hover:text-red-600 transition"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Section */}
      <div className="grid md:grid-cols-2 gap-12 mt-16">
        {/* NOTE */}
        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4">
            Leave a note with your order
          </h4>

          <textarea
            value={note}
            onChange={(e) => dispatch(setNote(e.target.value))}
            className="w-full h-40 border rounded p-4 focus:outline-none focus:ring-1 focus:ring-black"
            placeholder="Special instructions..."
          />
        </div>

        {/* TOTAL + CHECKOUT */}
        <div className="md:text-right text-center">
          <div className="text-lg font-serif">
            <span className="font-semibold">Total</span>
          </div>

          <div className="text-2xl font-serif mt-2">
            ${cartTotal.toFixed(2)} NZD
          </div>

          <p className="text-sm text-gray-500 mt-2">
            Shipping & taxes calculated at checkout
          </p>

          <div className="mt-6 flex lg:flex-row flex-col md:justify-end gap-6 items-center">
            <button
              className="uppercase tracking-widest text-sm underline text-neonYellow animate-neonFlicker order-2 lg:order-1"
              onClick={() => navigate("/menu")}
            >
              Continue Ordering
            </button>

            <button
              className="bg-black text-white px-6 py-3 uppercase tracking-widest hover:opacity-90 transition order-1 lg:order-2"
              onClick={() => navigate("/checkout")}
            >
              Checkout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartMenu;
